import script from "./DescriptionView.vue?vue&type=script&setup=true&lang=ts"
export * from "./DescriptionView.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__